import { PaginationRequestType } from '../../../../types/paginationRequestType';
import { CreateSurveyDraftRequest } from './SurveyDraft';
import { SectionKind } from './types';

export enum SurveyContext {
  TeacherEvaluationForStudents = 'teacher-evaluation-for-students',
  CourseEvaluationForTeachers = 'course-evaluation-for-teachers',
}

export const surveyContextTexts = {
  [SurveyContext.TeacherEvaluationForStudents]:
    'Encuesta de curso para estudiantes',
  [SurveyContext.CourseEvaluationForTeachers]:
    'Encuesta por Curso para Docentes',
} as const;

export enum SurveyStatus {
  Published = 'published',
  Finished = 'finished',
}

export const surveyStatusTexts = {
  [SurveyStatus.Published]: 'Publicada',
  [SurveyStatus.Finished]: 'Finalizada',
} as const;

export enum SurveyRespondentType {
  Student = 'student',
  Admin = 'admin',
  Teacher = 'teacher',
}

export const respondentTypes = {
  [SurveyContext.TeacherEvaluationForStudents]: 'Alumnos',
  [SurveyContext.CourseEvaluationForTeachers]: 'Docentes',
} as const;

interface Period {
  id: number;
  periodTypeId: string;
  moodleCategoryId: number;
  code: string;
  name: string;
  description: string | null;
  creditMin: number;
  creditMax: number;
  startDate: string;
  endDate: string;
  academicYear: number;
  lastLoadDate: string;
  loadingDeadline: string | null;
  uploadDateSectionAttributes: string;
  sectionAttributesUploadDeadline: string | null;
  createdAt: string;
  updatedAt: string;
  active: boolean;
}

interface SurveyPeriod {
  id: number;
  period: Period;
}

export interface Survey {
  id: string;
  title: string;
  description: string;
  startDate: string;
  endDate: string;
  context: string;
  status: SurveyStatus;
  createdAt: string;
  updatedAt: string;
  surveyPeriod: SurveyPeriod[];
  sections: SurveySection[];
}

export type SurveyListResponseType = PaginationRequestType<Survey>;

export interface CreateSurveyRequest extends CreateSurveyDraftRequest {}
export interface SurveySection {
  id: string;
  name: string;
  description: string | null;
  order: number;
  kind?: SectionKind;
  isExpanded?: boolean;
  createdAt: string;
  updatedAt: string;
  questions: SurveyQuestion[];
}

export interface SurveyQuestion {
  id: string;
  text: string;
  order: number | null;
  isActive?: boolean;
  responses: SurveyResponse[];
  evaluationScale?: SurveyEvaluationScale | null;
  type: string;
  metadata?: Record<string, any> | null;
}

export interface SurveyResponse {
  id: string;
  // Las respuestas cerradas guardan null: el texto solo lo escriben las abiertas.
  responseText: string | null;
}

export interface SurveyEvaluationScale {
  id: string;
  title: string;
  options: ScaleOptions[];
}

export interface SurveyOption {
  id: string;
  title: string;
  description: string | null;
  order: number;
}

export interface ScaleOptions {
  id: string;
  optionNumber: number;
  description: string;
}
